// extracted by mini-css-extract-plugin
export var courseTasks = "screen5-module--course-tasks--b7258";
export var task__item = "screen5-module--task__item--67c43";
export var task__itemText = "screen5-module--task__item-text--8fe15";
export var task__itemTitle = "screen5-module--task__item-title--34285";
export var tasks__block = "screen5-module--tasks__block--29dce";